export const statusColor = (health: string): { color: string, background: string } => {
  switch (health) {
    case 'off_track':
      return { color: '#F92323', background: 'rgba(249, 35, 35, 0.2)' }
    case 'at_risk':
      return { color: '#FF920F', background: 'rgba(255, 146, 15, 0.2)' }
    case 'on_track':
      return { color: '#00D85A', background: 'rgba(0, 216, 90, 0.2)' }
    case 'upcoming':
      return { color: '#929292', background: 'rgba(146, 146, 146, 0.2)' }
    case 'completed':
      return { color: '#4185FF', background: 'rgba(65, 133, 255, 0.2)' }
    case 'in_progress':
      return { color: '#FFBE41', background: 'rgba(255, 190, 65, 0.2)' }
    default:
      return { color: '', background: '' }
  }
}
